export interface EmergencyContactModel {
  HRRef: number;
  KeyID: number;
  Contact: string;
  HomePhone: string;
  CellPhone: string;
  Relationship: string;
  IsToDelete: boolean;
}
